import { render } from "./bunchChangeCardStatusPopup.vue?vue&type=template&id=fbbb08b4&scoped=true"
import script from "./bunchChangeCardStatusPopup.vue?vue&type=script&lang=js"
export * from "./bunchChangeCardStatusPopup.vue?vue&type=script&lang=js"

import "./bunchChangeCardStatusPopup.vue?vue&type=style&index=0&id=fbbb08b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbb08b4"]])

export default __exports__